import { render } from "./WishListItem.vue?vue&type=template&id=39382c09&scoped=true"
import script from "./WishListItem.vue?vue&type=script&lang=js"
export * from "./WishListItem.vue?vue&type=script&lang=js"

import "./WishListItem.vue?vue&type=style&index=0&id=39382c09&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39382c09"]])

export default __exports__